import { render } from "./EditDistributorScore.vue?vue&type=template&id=3dc0b079&scoped=true"
import script from "./EditDistributorScore.vue?vue&type=script&lang=js"
export * from "./EditDistributorScore.vue?vue&type=script&lang=js"

import "./EditDistributorScore.vue?vue&type=style&index=0&id=3dc0b079&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3dc0b079"]])

export default __exports__